<template>
    <div class="quiz__sidebar">
        <ul>
            <li v-for="(question, i) in questions" :class="{ active: isCurrentStep(i) }" :key="i">
                <p>{{ i + 1 }}. {{ question }}</p>
                <p>{{ getAnswer(i) | option_text | capitalize }}</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        questions: { type: Array, required: true },
        answers: { type: Array, required: true },
    },
    methods: {
        getAnswer(index) {
            return this.answers[index]
        },
        isCurrentStep(index) {
            return Object.keys(this.$route.params).length >= index
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/sidebar.vue